let css = require('./content.css');
let Login = require('../login');
let Registration = require('../registration');
let RegistrationExtra = require('../registration-extra');
let Restore = require('../restore');
let RestoreChange = require('../restore-change');
let Alert = require('../alert');

class Content {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Content,
    children: [
        {
            name: 'login',
            component: Login,
            watcher: {
                isDisabled: ['login', 'ui', 'loginButton', 'isDisabled'],
                email: ['login', 'tooltip', 'emailNotConfirmed', 'username'],
                showEmailNotConfirmedTooltip: ['login', 'tooltip', 'emailNotConfirmed', 'show'],
                showEmailNotConfirmedMailResendTooltip: ['login', 'tooltip', 'emailNotConfirmedMailResend', 'show'],
                showAlreadyRegisteredTooltip: ['login', 'tooltip', 'showAlreadyRegisteredTooltip'],
                utm: ['utm']
            }
        },
        {
            name: 'registration',
            component: Registration,
            watcher: {
                isEnabled: ['registration', 'computed', 'registerButton', 'isEnabled'],
                showToS: ['registration', 'showToS'],
                userType: ['registration', 'form', 'userType']
            }
        },
        {
            name: 'registration-extra',
            component: RegistrationExtra,
            watcher: {
                isEnabled: ['registrationExtra', 'computed', 'registerButton', 'isEnabled'],
                showToS: ['registrationExtra', 'showToS'],
                userType: ['registrationExtra', 'form', 'userType'],
                isBitrix: ['bitrix', 'isBitrix']
            }
        },
        {
            name: 'restore',
            component: Restore,
            watcher: {
                isEnabled: ['restore', 'computed', 'restoreButton', 'isEnabled']
            }
        },
        {
            name: 'restore-change',
            component: RestoreChange,
            watcher: {
                isEnabled: ['restoreChange', 'computed', 'restoreButton', 'isEnabled']
            }
        },
        {
            name: 'alert',
            component: Alert,
            watcher: {
                email: ['auth', 'computed', 'userData', 'email'],
                type: ['auth', 'alert', 'type']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/auth/content/index.js